import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Privcy from "../assets/footerimage/privacy-policy.jpeg";
import { Helmet } from "react-helmet-async";

const privacyPolicyData = [
  {
    heading: "Your privacy protection is  our commitment",
    content: `Deetya Soft knows the importance of your privacy regardless whether you are a customer or visitor of our website and we are committed to protect the personal information or data, that we have collected when you visit our portal. So, Deetya Soft has created the following Privacy Policy.`,
  },
  {
    heading: "What does Personally identifiable information means?",
    content: `"Personally identifiable information" means any information that may be used to identify an individual, including, but not limited to, a first and last name, home or other physical address, an email address, phone number or other contact information, whether at work or at home. When you use our website or services Deetya Soft may collect from you the following personally identifiable information: first and last name, city, state and zip code, email address, birthday, and phone number. Deetya Soft also automatically receives and records information on our server logs from your browser, including your IP address, cookie information and the page you request. You can choose not to provide us with certain information, but then you might not be able to take advantage of many of our features.
Deetya Soft may keep a cached copy of the content you serve us as a part of your use of the service for an indeterminate amount of time, including media files and XML files. To assist in development, we may keep copies of HTTP requests and responses in your notification log, available only to you. If your web server does not specify that we can cache your content, we will not keep a cached copy of any text or audio data transmitted through our service during calls, but we may still maintain copies in your notification log. If data privacy is a concern, make sure your server does not allow us to cache such content, and contact us so that we may turn off other application logging around requests to and responses from your application. We may keep call log, notification log, billing/ payment, and other log data for at least six months from the date of entry.`,
  },
  {
    heading: "How Is Such Information Used?",
    content: `Deetya Soft uses the personally identifiable and other collected information in a manner that is consistent with this Privacy Policy. If you provide personally identifiable information for a certain reason, we may use the personally identifiable information in connection with the reason for which it was provided. For instance, if you contact us by e-mail, we will use the personally identifiable information you provide to answer your question or resolve your problem. Also, if you provide personally identifiable information in order to obtain access to the Deetya Soft website or services, we will use such information to provide you with access to such services and to monitor your use of such services. Your personally identifiable information may be used to provide you with new product information and support services offered on the website, to notify you of technical updates or changes in policy, to improve the content and functionality of the Deetya Soft website and services, to help us better understand our users, or to deliver other services.`,
  },
  {
    heading: "No Information is Shared or Disclosed to Third Party?",
    content: `Deetya Soft is not in the business of selling your information. We consider this information to be a vital part of our relationship with you. There are, however, certain circumstances in which we may share your personally identifiable information with certain third parties without further notice to you, as set forth below:`,
  },
  {
    heading: "Third Party Applications and Services",
    content: `If you choose to use third-party applications with Deetya Soft via Deetya Soft Connect, they may access your data (including personal information) generated through our services. Deetya Soft is not responsible for the policies or actions of these third-party providers. Please review their privacy policies to understand how they handle your data.`,
  },
  {
    heading: "Business Transfers",
    content: `As we grow, we may buy or sell businesses or assets. In such events (like a sale, merger, or reorganization), personal information may be transferred. You acknowledge these transfers and agree that any successor to Deetya Soft may continue using your information as described in this policy.`,
  },
  {
    heading: "Related Companies",
    content: `We may also share your personally identifiable information with any entity that is affiliated with us for purposes consistent with this Privacy Policy.

`,
  },
  {
    heading: "Agents, Consultants, and Related Third Parties",
    content: `Deetya Soft may use third-party companies for certain functions like mailing, database management, or payment processing. These companies receive only the information needed to perform their specific tasks.`,
  },
  {
    heading: "Legal Requirements and Other Circumstances",
    content: `Deetya Soft may disclose your personally identifiable information if required to do so by law or in the good faith belief that such action is necessary to

(i) comply with a legal obligation

(ii) protect and defend the rights or property of Deetya Soft,

(iii) act in urgent circumstances to protect the personal safety of users of the Deetya Soft website or services or the public, or

(iv) protect against legal liability.
`,
  },
  {
    heading: "Access",
    content: `If you have volunteered personally identifiable information, you may correct or amend that information by editing your account Profile and email us at Parshan.kumar@gmail.com`,
  },
  {
    heading: "The Security of Your Information",
    content: `We will take reasonable precautions to protect personally identifiable information in our possession from loss, misuse, and unauthorized access, disclosure, alteration, and destruction. We follow generally accepted industry standards to protect the personally identifiable information submitted to us, both during transmission and once we receive it. No method of transmission over the Internet or method of electronic storage is, however, 100% secure. Therefore, while we strive to use commercially acceptable means to protect your personally identifiable information, we cannot guarantee its absolute security.`,
  },
  {
    heading: "Cookies",
    content: `Cookies are small text files stored by your browser in your computer when you visit our website. Cookies permit us to recognize users and avoid repetitive requests for the same information. Most browsers will accept cookies until you change your browser settings to refuse them. This privacy statement covers the use of cookies by Deetya Soft and does not cover the use of cookies by any other third party.`,
  },
  {
    heading: "Analytics and Tracking",
    content: `We may use third-party analytics services like Google Analytics to analyze traffic and usage patterns on our site. These services may collect information about your visit, including your IP address and behavior on our site.`,
  },
  {
    heading: "Forums and Comments",
    content: `If you use the forum or post comments on this website, you should be aware that any personally identifiable information you submit there can be read, collected, or used by other users of these forums.`,
  },
  {
    heading: "Other Websites Links",
    content: `This website may contain links to other sites that are not owned or controlled by us. Please be aware that Deetya Soft is not responsible for the privacy policies of such other sites. We encourage you to be aware when you leave our site and to read the privacy statements of each website that collects personally identifiable information. This privacy policy applies only to information collected by this website.`,
  },
  {
    heading: "Your Consent To This Privacy Policy",
    content: `By using Deetya Soft, you agree to this Privacy Policy. It replaces any previous version. Our Terms of Service override any conflicting terms here. We may update this policy by posting changes on our website, and it's your responsibility to review them. Continued use of our site or services means you accept the updated policy.`,
  },
  {
    heading: "Contact Us",
    content: `If you believe Deetya Soft has violated this Privacy Policy, please contact us at Parshan.kumar@gmail.com or by mail at Deetya Soft Private Limited, FF-06, First Floor, Mahaluxmi Square, Plot No. C-1, Abhay Khand-II, Indirapuram, Ghaziabad, Uttar Pradesh - 201014, INDIA. We’ll make reasonable efforts to resolve the issue.`,
  },
];

export default function PrivacyPolicy() {
  const [activeSection, setActiveSection] = useState("");

  const handleScroll = () => {
    const scrollPosition = window.scrollY + 100;
    privacyPolicyData.forEach(({ heading }) => {
      const element = document.getElementById(heading);
      if (element && element.offsetTop <= scrollPosition) {
        setActiveSection(heading);
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 20,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Deetyasoft IVR & Cloud Communication</title>
        <meta
          name="description"
          content="Learn how Deetyasoft collects, uses, and protects your data. Our privacy policy ensures secure handling of IVR  and cloud telephony user information."
        />
        <meta
          name="keywords"
          content="Deetyasoft terms, IVR service terms, cloud solutions policy, service agreement Deetyasoft, IVR usage conditions, cloud telephony rules"
        />
        <link rel="canonical" href="https://deetyasoft.com/privacy-policy" />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/privacy-policy"
        />
        <meta
          property="og:title"
          content="Privacy Policy | Deetyasoft IVR & Cloud Communication"
        />
        <meta
          property="og:description"
          content="Learn how Deetyasoft collects, uses, and protects your data. Our privacy policy ensures secure handling of IVR  and cloud telephony user information."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/privacy-policy.b7385f612d39898da58c.jpeg"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/privacy-policy"
        />
        <meta
          name="twitter:title"
          content="Privacy Policy | Deetyasoft IVR & Cloud Communication"
        />
        <meta
          name="twitter:description"
          content="Learn how Deetyasoft collects, uses, and protects your data. Our privacy policy ensures secure handling of IVR  and cloud telephony user information."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/privacy-policy.b7385f612d39898da58c.jpeg"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Organization",
              name: "Deetya Soft Pvt Ltd",
              description:
                "Learn how Deetyasoft collects, uses, and protects your data. Our privacy policy ensures secure handling of IVR  and cloud telephony user information.",
              image:
                "https://deetyasoft.com/static/media/privacy-policy.b7385f612d39898da58c.jpeg",
              logo: "https://www.deetyasoft.com/images/logo.png",
              url: "https://www.deetyasoft.com",
              telephone: ["+91-9015350505", "+91-9717055088"],
              email: "info@deetyasoft.com",
              sameAs: [
                "https://www.linkedin.com/company/deetya-soft-private-limited",
                "https://www.facebook.com/deetyasoftprivatelimited",
                "https://www.instagram.com/deetyasoft",
                "https://www.youtube.com/@deetyasoft",
                "https://www.crunchbase.com/organization/deetyasoft",
              ],
              address: {
                "@type": "PostalAddress",
                streetAddress:
                  "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
                addressLocality: "Ghaziabad",
                addressRegion: "Uttar Pradesh",
                postalCode: "201014",
                addressCountry: "IN",
              },
            }),
          }}
        />

        {/* Contact Points */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Organization",
              url: "https://www.deetyasoft.com",
              contactPoint: [
                {
                  "@type": "ContactPoint",
                  telephone: "+91-981-862-7588",
                  contactType: "technical support",
                  areaServed: "IN",
                },
                {
                  "@type": "ContactPoint",
                  telephone: "+91-901-535-0505",
                  contactType: "sales",
                  areaServed: "IN",
                },
              ],
            }),
          }}
        />

        {/* Review Block */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "Parshan ",
              },
              reviewBody:
                "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
              url: "https://www.deetyasoft.com/",
              description:
                "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
              datePublished: "2025-06-17",
              name: "Deetya Soft Pvt Ltd",
              reviewRating: {
                "@type": "Rating",
                worstRating: "1",
                ratingValue: "5",
                bestRating: "5",
              },
              itemReviewed: {
                "@type": "Organization",
                name: "Deetya Soft Pvt Ltd",
              },
            }),
          }}
        />
      </Helmet>
      <div className="relative w-full h-[60vh] md:h-[70vh] bg-black">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src={Privcy}
            alt="privacy-policy"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center items-start h-full px-6 md:px-16 text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            privacy policy
          </h1>
          <div className="flex items-center space-x-2 text-sm md:text-base">
            <Link to="/" className="text-white hover:underline font-bold">
              Home
            </Link>
            <span className="text-red-500">●</span>
            <span className="text-gray-300">privacy policy</span>
          </div>
        </div>
      </div>
      <div className="container mx-auto my-5 px-4 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-1 md:sticky md:top-20 bg-white shadow-lg rounded-lg p-4">
          {/* <h2 className="text-xl font-bold mb-4">Table of Contents</h2> */}
          <ul className="space-y-2 sticky top-28 ">
            {privacyPolicyData.map(({ heading }) => (
              <li
                key={heading}
                className={`cursor-pointer p-2 rounded-lg transition-all duration-200 ${
                  activeSection === heading
                    ? "text-black font-semibold border-l-4 border-main bg-gray-100"
                    : "text-gray-600 hover:text-black hover:bg-gray-50"
                }`}
                onClick={() => scrollToSection(heading)}
              >
                {heading}
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3 space-y-3">
          {privacyPolicyData.map(({ heading, content }) => (
            <div id={heading} key={heading}>
              <h3 className="text-main text-xl font-semibold mb-2">
                {heading}
              </h3>
              <p className="mb-2 md:text-base text-sm">{content}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
